import { RouteConfig } from 'vue-router'

import {
	EmployeesIndex,
    CreateEditEmployee
} from '@/views'

const employeesRouter: Array<RouteConfig> = [
	{
		path: 'employees',
		component: EmployeesIndex,
		name: 'employees',
		meta: {
			requiresVisitor: false,
			requiresAuth: true,
			title: 'Maestro de Empleados'
		}
	},
    {
		path: 'employees/form',
		component: CreateEditEmployee,
		name: 'employees-form',
		meta: {
			requiresVisitor: false,
			requiresAuth: true,
			title: 'Crear Empleados'
		}
	},
	{
		path: 'employees/form/:id',
		component: CreateEditEmployee,
		name: 'employees-form-edit',
		meta: {
			requiresVisitor: false,
			requiresAuth: true,
			title: 'Editar Empleados'
		}
	}
]

export default employeesRouter
